import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';
import { openWhatsApp, whatsappNumbers } from '../mock';
import paulaPhoto from '../assets/team/paula.webp';
import julietaPhoto from '../assets/team/julieta.webp';

export const teamMembers = [
  {
    id: 'paula',
    name: 'Paula M. Benitez Sampellegrini',
    specialty: 'Derecho de Familia',
    experience: '20 años de experiencia en el Fuero',
    matricula: 'Matrícula T° V F° 101 del CALM',
    matriculaExtra: 'Matrícula T° 112 F° 442 CPACF (CABA)',
    whatsapp: whatsappNumbers.primary,
    whatsappLabel: 'WhatsApp Paula',
    waLabel: 'team-paula',
    photo: paulaPhoto
  },
  {
    id: 'julieta',
    name: 'Julieta B. Jaliff',
    specialty: 'Despidos, ART y Sucesiones',
    experience: '9 años de experiencia',
    matricula: 'Matrícula T° X F° 296 del CALM',
    whatsapp: whatsappNumbers.secondary,
    whatsappLabel: 'WhatsApp Julieta',
    waLabel: 'team-julieta',
    photo: julietaPhoto
  }
];

const handleWhatsAppClick = (phoneNumber, name, waLabel) => {
  const message = `Hola ${name.split(' ')[0]}, me gustaría iniciar una consulta legal.`;
  openWhatsApp(phoneNumber, message, waLabel);
};

export const TeamGrid = ({ members, testidPrefix = 'team', className = '' }) => (
    <div className={`team-grid ${className} ${members.length === 1 ? 'team-grid-single' : ''}`}>
      {members.map((member, index) => (
        <Card key={index} className="team-card">
          <div className="team-photo-placeholder">
            {member.photo ? (
              <img
                src={member.photo}
                alt={`Fotografía profesional de ${member.name}`}
                className="team-photo-img"
                loading="lazy"
                data-testid={`${testidPrefix}-photo-${index}`}
              />
            ) : (
              <div className="photo-frame">
                <p className="photo-placeholder-text">Fotografía profesional</p>
              </div>
            )}
          </div>
          <CardContent className="team-card-content">
            <h3 className="team-member-name">{member.name}</h3>
            <p className="team-member-specialty">{member.specialty}</p>
            <p className="team-member-experience">{member.experience}</p>
            <p className="team-member-matricula">{member.matricula}</p>
            {member.matriculaExtra && (
              <p className="team-member-matricula">{member.matriculaExtra}</p>
            )}
            <Button
              onClick={() => handleWhatsAppClick(member.whatsapp, member.name, `${member.waLabel}${testidPrefix === 'team' ? '' : '-' + testidPrefix}`)}
              className="team-whatsapp-btn"
              data-action="whatsapp-click"
              data-wa-label={member.waLabel}
              data-testid={`${testidPrefix}-whatsapp-${index}`}
            >
              <MessageCircle className="w-4 h-4 mr-2" />
              {member.whatsappLabel}
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
);

const TeamSection = ({
  members = teamMembers,
  title = 'Conocé a nuestro equipo.',
  subtitle = 'Dos profesionales comprometidas con tu tranquilidad y bienestar legal.',
  sectionId = 'equipo',
  variant = '',
  testidPrefix = 'team'
}) => {
  return (
    <section className={`team-section ${variant}`} id={sectionId} data-testid={`${testidPrefix}-section`}>
      <div className="team-container">
        <h2 className="team-title">{title}</h2>
        <p className="team-subtitle">{subtitle}</p>
        <TeamGrid members={members} testidPrefix={testidPrefix} />
      </div>
    </section>
  );
};

export default TeamSection;